import { call, put, select } from "redux-saga/effects";

import * as actions from "../actions";
import history from "../../history";

import * as Api from "../../api";

const RTW_VERIFICATION_CALL_ENABLED = "1";

export function* rightToWorkCheck({ payload }) {
  try {
    const response = yield call(Api.submitRightToWork, payload);
    if (response.status === 200) {
      yield put(actions.rightToWorkSuccess(response.data));
    } else {
      yield put(actions.addError("RightToWork", response));
      throw new Error(
        `Failed to process right to work request: ${response.status}`
      );
    }
  } catch (error) {
    yield put(actions.addError("RightToWork", error));
    yield put(actions.rightToWorkError(error));
  }
}

export function* rightToWorkSuccess() {
  try {
    if (RTW_VERIFICATION_CALL_ENABLED !== "1") {
      yield history.push("/profile");
    }
  } catch (error) {
    yield put(actions.addError("RightToWork", error));
  }
}

export function* rightToWorkVerificationQueueSize() {
  try {
    yield put(actions.rightToWorkVerificationSetIsLoading(true));
    const response = yield call(Api.getRTWVerificationQueueSize);
    if (response.status === 200) {
      yield put(
        actions.rightToWorkVerificationQueueSizeSuccess(response.data.data)
      );
    } else {
      yield put(actions.addError("RightToWorkVerification", response));
      throw new Error(
        `Failed to process right to work verification queue size request: ${response.status}`
      );
    }
  } catch (error) {
    yield put(actions.addError("RightToWorkVerification", error));
    yield put(actions.rightToWorkError(error));
  } finally {
    yield put(actions.rightToWorkVerificationSetIsLoading(false));
  }
}

export function* rightToWorkVerificationQueueRegister() {
  try {
    yield put(actions.rightToWorkVerificationSetIsLoading(true));
    const response = yield call(Api.getRTWVerificationQueueRegister);
    if (response.status === 200) {
      yield put(
        actions.rightToWorkVerificationQueueDetails(response.data.data)
      );
    } else {
      yield put(actions.addError("RightToWorkVerification", response));
      throw new Error(
        `Failed to process right to work verification registration request: ${response.status}`
      );
    }
  } catch (error) {
    yield put(actions.addError("RightToWorkVerification", error));
    yield put(actions.rightToWorkError(error));
  } finally {
    yield put(actions.rightToWorkVerificationSetIsLoading(false));
  }
}

const getQueueToken = (state) =>
  state.core.rtwVerificationCall && state.core.rtwVerificationCall.token;

const getConnectionLink = (state) =>
  state.core.rtwVerificationCall &&
  state.core.rtwVerificationCall.connectionLink;

export function* rightToWorkVerificationQueuePosition() {
  try {
    yield put(actions.rightToWorkVerificationSetIsLoading(true));
    const queueToken = yield select(getQueueToken);
    const connectionLink = yield select(getConnectionLink);
    if (queueToken && !connectionLink) {
      const response = yield call(
        Api.getRTWVerificationQueuePosition,
        queueToken
      );
      if (response.status === 200) {
        yield put(
          actions.rightToWorkVerificationQueueDetails(response.data.data)
        );
      } else {
        yield put(actions.addError("RightToWorkVerification", response));
        throw new Error(
          `Failed to process right to work verification queue position request: ${response.status}`
        );
      }
    }
  } catch (error) {
    yield put(actions.addError("RightToWorkVerification", error));
    yield put(actions.rightToWorkError(error));
  } finally {
    yield put(actions.rightToWorkVerificationSetIsLoading(false));
  }
}
